import React from 'react';

import delv from 'dlv';
import { Helmet } from 'react-helmet-async';

import { ISanityImage } from '@rbi-ctg/menu';
import { fullBrandName } from 'utils/environment';

interface IStoreMeta {
  storeUrl: string;
  phoneNumber: string;
  city: string;
  state: string;
  postalCode: string;
  streetAddress: string;
  atCopy: string;
  image?: ISanityImage;
}

interface ILdJsonRestaurant {
  '@context': 'http://schema.org';
  '@type': 'Restaurant';
  address: {
    '@type': 'PostalAddress';
    addressLocality: string;
    addressRegion: string;
    postalCode: string;
    streetAddress: string;
  };
  name: string;
  telephone: string;
  url: string;
  image?: string;
}

export const StoreMeta: React.FC<IStoreMeta> = ({
  storeUrl,
  phoneNumber,
  city,
  state,
  postalCode,
  streetAddress,
  atCopy,
  image,
}) => {
  const ldJsonRestauranData: ILdJsonRestaurant = {
    '@context': 'http://schema.org',
    '@type': 'Restaurant',
    address: {
      '@type': 'PostalAddress',
      addressLocality: city,
      addressRegion: state,
      postalCode,
      streetAddress,
    },
    name: `${fullBrandName()} ${atCopy} ${streetAddress}`,
    telephone: phoneNumber,
    url: storeUrl,
  };

  if (image) {
    ldJsonRestauranData.image = delv(image, 'asset.url');
  }

  return (
    <Helmet>
      <title>{streetAddress}</title>
      <script type="application/ld+json">{JSON.stringify(ldJsonRestauranData)}</script>
    </Helmet>
  );
};

export const Meta = StoreMeta;
